import React, { Component } from 'react';
import { func, object, string } from 'prop-types';
import { connect } from 'react-redux';

import NoteEditorViews from './views';
import { autoSaveNoteText, createNote, resetAnnotation } from 'PipeRouter';


const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

class NoteEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaveDisabled: true,
      noteText: this.props.selectedHighlight.noteText
    };
  }

  handleChange = event => {
    const editNoteText = event.currentTarget.value;
    let isSaveDisabled = false;

    if (editNoteText.length === 0) {
      isSaveDisabled = true;
    }

    this.props.autoSaveNoteText(editNoteText);
    this.setState({
      isSaveDisabled,
      noteText: editNoteText
    });
  };

  cancelNote = () => {
    const { resetAnnotation } = this.props;
    resetAnnotation();
  };

  saveNote = () => {
    const { createNote, selectedHighlight } = this.props;
    createNote(selectedHighlight);
  };

  onKeyDown = event => {
    const { currentTarget, keyCode, shiftKey, target } = event;

    if ( keyCode === keys.tab) {
      if (shiftKey) {
        if (target.tagName === 'TEXTAREA') {
          currentTarget.getElementsByTagName('button')[1].focus();
          event.preventDefault();
          return;
        }

        if (target.textContent === 'Cancel') {
          currentTarget.getElementsByTagName('button')[0].focus();
          event.preventDefault();
          return;
        }
      }

      if (target.textContent === 'Cancel') {
        event.currentTarget.getElementsByTagName('textarea')[0].focus();
        event.preventDefault();
        return;
      }
    }
  };

  render() {
    const { isSaveDisabled, noteText } = this.state;
    const { selectedHighlight } = this.props;

    const styles = {
      backgroundColor: selectedHighlight.color,
      border: `1px solid ${selectedHighlight.darkColor}`
    };

    const viewProps = {
      cancelNote: this.cancelNote,
      handleChange: this.handleChange,
      isSaveDisabled,
      noteText,
      onKeyDown: this.onKeyDown,
      saveNote: this.saveNote,
      styles
    };

    return <NoteEditorViews { ...viewProps } />;
  }
}

NoteEditor.propTypes = {
  autoSaveNoteText: func,
  cancelNote: func,
  create: func,
  noteText: string,
  selectedHighlight: object
};


function mapStateToProps(state) {
  return {
    selectedHighlight: state.selectedHighlight
  };
}

export default connect(mapStateToProps, {
  autoSaveNoteText,
  createNote,
  resetAnnotation
})(NoteEditor);
